import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';

import {colors, mobileMediaQuery, notWebMediaQuery} from './../../styles';

import {ReactComponent as CloseIcon} from './../../assets/close.svg';

const Container = styled.div`
    position: fixed;
    background-color: rgba(0, 0, 0, 0.8);
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 80px;

    @media screen and (max-height: 550px) {
        padding: 40px 0px;
        overflow-y: auto;
    }

    ${notWebMediaQuery} {
        margin-top: 0px;
    }
`;

const ModalBody = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    background-color: #fff;
    border-radius: 1rem;
    padding: 48px 44px;
    flex: 0.5;
    position: relative;
    max-width: 600px;
    max-height: calc(100vh - 210px);

    ${mobileMediaQuery} {
        flex: 1;
        max-width: calc(100vw - 40px);
        box-sizing: border-box;
    }
`;

const CloseButton = styled.button`
    position: absolute;
    top: 0px;
    right: 0px;
    margin: 1rem;
    border: 0;
    background: transparent;
    cursor: pointer;

    ${mobileMediaQuery} {
        margin: 0.5rem;
    }
`;

const Title = styled.h1`
    color: ${colors.cartoonBlack};
    font-family: 'AvenirNextRoundedStd';
    font-size: 20px;
    line-height: 24px;
    margin-top: 0;
    max-width: 540px;
    margin-right: auto;

    ${mobileMediaQuery} {
        font-size: 18px;
        line-height: 22px;
    }
`;

const Body = styled.div`
    img {
        max-height: 35vh;
        object-fit: contain;
    }
`;

const Footer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 24px;

    ${mobileMediaQuery} {
        button {
            padding: 14px 28px 14px;
            font-size: 1.25rem;

            ${mobileMediaQuery} {
                font-size: 1.25rem;
                padding: 0.75rem 1.5rem !important;
            }
        }
    }
`;

const Modal = ({title, buttons, children, content, ...props}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const bodyElement = document.querySelector('body');

    useEffect(() => {
        let top = window.scrollY;

        bodyElement.style.position = 'fixed';
        bodyElement.style.top = `-${top}px`;
        bodyElement.style.left = '0px';
        bodyElement.style.right = '0px';

        return () => {
            handleCloseModal();
        };

        // eslint-disable-next-line
    }, []);

    const handleCloseModal = () => {
        const scrollY = bodyElement.style.top;

        bodyElement.style.position = '';
        bodyElement.style.top = '';
        bodyElement.style.left = '';
        bodyElement.style.right = '';

        window.scrollTo(0, -parseInt(scrollY || '0'));

        dispatch({type: 'MODAL_CLOSE'});
    };

    if ((children && !children.$$typeof) || (buttons && !buttons.$$typeof))
        return null;

    return (
        <Container>
            <ModalBody>
                {props.hideClose !== true && (
                    <CloseButton onClick={handleCloseModal}>
                        <CloseIcon
                            title={t('controls.close')}
                            height="28px"
                            width="28px"
                        />
                    </CloseButton>
                )}
                <Title>{title}</Title>
                <Body>{children || content}</Body>
                <Footer>{buttons}</Footer>
            </ModalBody>
        </Container>
    );
};

export default Modal;
